import * as style from './style.css';
import DOMPurify from 'isomorphic-dompurify';
import type * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

interface IDescriptionProps {
  text: string;
}

export const Description = ({ text }: IDescriptionProps): React.JSX.Element => {
  return (
    <UIText2>
      <div
        // oxlint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
        className={style['container']}
      />
    </UIText2>
  );
};
